import { Application } from "@enums/application.enums";

export const AIGenerateConsts = {
  GenerateWithAI: 'Insert AI Generated Content',
  GENERATE: 'GENERATE',
  REGENERATE: 'REGENERATE',
  INSERT: 'INSERT',
  CANCEL: 'CANCEL',
  GeneratingContent: 'Generating content...',
  NewsletterPreview: 'Newsletter Preview',
  GeneratedContentPreview: 'Content Preview',
  GeneratedContentPreviewNote: 'Note: You can edit after inserting',
  ArticlePreview: 'Article Preview',
  PromptLabel: 'Explain what content you would like generated:',
  PromptPlaceholder: 'Describe the content you want to create...',
  ContentType: 'Content Type',
  GenerateANewsletterTitle: 'Generate a Newsletter Title',
  GenerateAnArticleTitle: 'Generate an Article Title',
  GenerateAnEmailSubjectLine: 'Generate an Email Subject Line',
  GenerateAPreviewImage: 'Generate a Cover Image'
};

export const AIGenerateIncludeOptions = (title: string) => [
  { label: `Full ${title} Text`, value: AIGenerateIncludeValues.text },
  { label: `Full ${title} Text with Images`, value: AIGenerateIncludeValues.text_image },
  { label: 'Specific Text Snippet', value: AIGenerateIncludeValues.text_snippet },
  { label: 'Single Image', value: AIGenerateIncludeValues.image }
];

export const AIGenerateIncludeValues = {
  text: 'text',
  text_image: 'text_image',
  text_snippet: 'text_snippet',
  image: 'image',
  email: 'email',
  email_with_image: 'email_with_image'
}

export const generateTypeToCheckboxLabel = (generateType: string) => {
  switch (generateType) {
    case Application.Newsletter:
      return AIGenerateConsts.GenerateANewsletterTitle;
    case Application.Article:
      return AIGenerateConsts.GenerateAnArticleTitle;
    case Application.SEND_INVITE:
    case Application.USER_SEGMENTATION:
      return AIGenerateConsts.GenerateAnEmailSubjectLine;
    default:
      return '';
  }
}